import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { TreasureBox } from "../api";
import "../common";
import { BaseResource } from "@kgsport-cms/common";
/***
 * created by 六月
 * 余额宝 相关接口
 * 2022-05-18
 *
 */
export var TreasureBoxService = /*#__PURE__*/function (_BaseResource) {
  _inherits(TreasureBoxService, _BaseResource);
  var _super = _createSuper(TreasureBoxService);
  function TreasureBoxService() {
    _classCallCheck(this, TreasureBoxService);
    return _super.apply(this, arguments);
  }
  _createClass(TreasureBoxService, [{
    key: "treasureBoxCommissionSettle",
    value:
    // 宝箱佣金结算
    function treasureBoxCommissionSettle(params) {
      return this.requester.get(TreasureBox.treasureBoxCommissionSettle, {
        params
      });
    }
    // 获取宝箱数据
  }, {
    key: "queryTreasureBoxCommission",
    value: function queryTreasureBoxCommission(params) {
      return this.requester.get(TreasureBox.queryTreasureBoxCommission, {
        params
      });
    }
    // 宝箱关闭接口
  }, {
    key: "treasureBoxClose",
    value: function treasureBoxClose(params) {
      return this.requester.get(TreasureBox.treasureBoxClose, {
        params
      });
    }
  }]);
  return TreasureBoxService;
}(BaseResource);